import { related, sourceIds } from './puzzles__urban-fresh-code.mdx';

export { sourceIds, related };
export const quickAnswer =
  'Urban Fresh 的密码是 1213。进入 West Incursion Zone 的 Urban Fresh，在收银机输入 1213 即可开启隐藏区域。';

## Urban Fresh 在哪里？

Urban Fresh 位于 West Incursion Zone。进入店内，找到可交互的收银机。先确认店名，避免在其他商店照搬数字密码。

## Urban Fresh 密码是多少？

密码是 **1213**，使用半角数字输入。

## 在哪里输入 1213？

依次输入 1、2、1、3，然后观察隐藏墙是否打开。这里使用数字，不是餐厅的字母输入。

## 输入后会打开什么？

隐藏墙会打开，通往 Secret Hideout。进入后收集生命升级物品。

## 密码输入后没反应怎么办？

核对四位输入及当前位置。若输入错了，重新输入完整密码，再检查墙面。进入秘密藏身处后收集生命升级物品。另一个字母密码见[公园 Atlantis](/puzzles/atlantis-code-the-park)。
